<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-col>
          <v-card class="mx-auto">
            <v-card-title>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span class="h6" v-bind="attrs" v-on="on">
                    <h4>Liste détaillée des séances d’évaluation des Offres/Propositions/Plis/Manifestations
                      d’Intérêts/Pré-qualifications</h4>
                  </span>
                </template>
                <span>Liste de programmation des séances d'évaluations des offres/propositions/plis ou
                  réponses des MI / APQ
                </span>
              </v-tooltip>
              <v-spacer></v-spacer><v-chip class="ma-2">{{
                  this.$store.getters["Auth/get_all_evaluation"].length
                }}</v-chip>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-virtual-scroll :items="this.$store.getters['Auth/get_all_evaluation']" :item-height="50" height="400">
                <template v-slot="{ item }">
                  <v-list-item>
                    <v-list-item-avatar>
                      <v-icon large>mdi-card-bulleted-settings</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                      <v-list-item-subtitle>{{
                  item.date | moment("dddd, Do MMMM YYYY à HH:mm:ss A")
                }}</v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-chip label small outlined :color="`${item.valid ? 'green' : 'red'}`">
                        {{ formatValid(item.valid) }}
                      </v-chip>


                      <v-btn @click="seemeeting(item)" depressed small>
                        Acceder
                        <v-chip outlined label class="mx-1" v-if="item.evalFin">SPF</v-chip>
                        <v-chip label outlined class="mx-1" v-if="item.evalTech">SPT</v-chip>
                        <v-icon color="orange darken-4" right>mdi-eye</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </template>
              </v-virtual-scroll>
            </v-card-text>
          </v-card>
        </v-col>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { mapActions } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import moment from "moment";

export default {
  components: {
    DatePicker
  },
  data: () => ({
    docTypeEval: [],
    Dtype: false
  }),
  created() {
    this.$store.dispatch("Auth/getAllConfigHome");
    this.$store.dispatch("Auth/getSubmissionFoldNoti");
    let Virt = [];

    Virt = JSON.parse(localStorage.getItem("userData"));
    this.profile = Virt.profile.status;
    this.user_data = Virt;
    this.$store.dispatch("Auth/loadAllNotice");
    this.$store.dispatch("Auth/loadAllDoc");
    this.$store.dispatch("Auth/loadAllEvaluation");
    this.$store.dispatch("Auth/loadAllCom");

    console.log("EVALUATION", this.$store.getters["Auth/get_all_evaluation"]);
  },
  methods: {
    ...mapActions({
      extension_addN: "Auth/extension_addN"
    }),
    formatValid(value) {
      return value ? "validé" : "non validé";
    },
    seemeeting(item) {
      //console.log(item);
      if (new Date() <= new Date(item.date)) {
        Swal.fire({
          title: "Attention !",
          text: `La seance d'evaluation est prévue pour le ${moment(item.date).format(
            "dddd, Do MMMM YYYY à HH:mm:ss A"
          )}`,
          icon: "error"
        });
      } else {
        this.$router.push({ name: "showRapportEval", params: { id: parseInt(item.id) } });
      }
    }
  }
};
</script>
<style>
.vue-daterange-picker {
  width: 100%;
}

.mx-datepicker {
  width: 100%;
}

.w-62em {
  height: 62em !important;
  width: 100% !important;
}

.v-card__text {
  width: 100% !important;
}

.vue-friendly-iframe iframe {
  width: 100% !important;
  height: 62em !important;
}
</style>